













































































































































































import {
    SfLoader,
} from '@storefront-ui/vue';

import {
    defineComponent, ref, useFetch, watch, onMounted, useContext
} from "@nuxtjs/composition-api";

import useStore from '~/modules/pageExten/composables/useStore';
import { CityResults, FindStoreResults} from '~/modules/pageExten/composables/useStore/useStore';
import { goongjsConfig } from "~/config/extensionsApi";
import { updateMapWithMarkers, gotoGgMap, initMap, stopScrollBody, startScrollBody, imageStore, createSmoothscroll, timeToMinutes, getStoreStatusText, getStoreStatusStyle } from "../helpers/store";
import { useClevertapStore } from "~/stores/clevertap";

export default defineComponent({
    name: "cnfStore",
    components: {
        SfLoader
    },

    setup() {
        const { listCity, findStore, detailStore, topStores, loading, error, listCityData } = useStore();
        const clevertapStore = useClevertapStore();
        const { app } = useContext();
        const cities = ref<CityResults[]>([]);
        const stores = ref<FindStoreResults[]>([]);
        const districts = ref<any[]>([]);
        const selectedCity = ref<number | null>(null);
        const selectedDistrict = ref<string | null>(null);
        const listStore = ref<any[]>([]);
        const markerGoong = ref<any[]>([]);
        const idStore = ref("");
        const storeByCity = ref<FindStoreResults[]>([]);
        const dataLocation = ref("");
        const checkIndexStore = ref("");
        const showTimeLine = ref("");
        const storeHighLight = ref<FindStoreResults[]>([]);
        const mapGoong = ref<any>(null);

        useFetch(async () => {
            const params = { country_id: "VN" };
            await listCity(params);
            cities.value = listCityData.value || [];

            if (!error.value.listCity) {
                let first = cities.value.find(e => e.value === 'Hà Nội');
                if (first) selectedCity.value = first.text;
            }

            storeHighLight.value = await topStores();
        });

        const getStoreByCity = async (store, index) => {
            if (checkIndexStore.value == index) {
                checkIndexStore.value = "";
            } else {
                checkIndexStore.value = index;
                if (store.text) {
                    const params = { city_id: store.text };
                    storeByCity.value = await findStore(params);
                    
                    // Track store list viewed when clicking on a city in the list
                    if (storeByCity.value && storeByCity.value.length > 0) {
                        trackStoreListViewed(storeByCity.value, 'from_city_list');
                    }
                }
            }
        };

        watch(selectedCity, (newValue) => {
            if (newValue) {
                liststore(newValue);
                selectedDistrict.value = null;
            }
        });

        const liststore = async (cityId) => {
            const params = { city_id: cityId };
            stores.value = await findStore(params);

            if (stores.value && !error.value.findStore) {
                districts.value = [];
                listStore.value = stores.value;

                stores.value.forEach(item => {
                    if (!districts.value.some(existingItem => existingItem.value === item.city)) {
                        districts.value.push({ id: item.city, value: item.city, latitude: item.latitude, longitude: item.longitude });
                    }
                });

                listStoreInMap(districts);
                
                // Track store list viewed event after stores are loaded
                trackStoreListViewed(stores.value);
            }
        };

        const listStoreInMap = (storeData) => {
            updateMapWithMarkers(storeData.value, mapGoong, markerGoong);
        };

        watch(selectedDistrict, (newValue) => {
            stores.value = listStore.value.filter(store => store.city === newValue);
            listStoreInMap(stores);
            
            // Track store list viewed when district changes
            if (stores.value && stores.value.length > 0) {
                trackStoreListViewed(stores.value, 'store_page');
            }
        });

        const storeInMap = (index, store) => {
            updateMapWithMarkers([store], mapGoong, markerGoong);
        };

        const goToMap = (storeDistric) => {
            updateMapWithMarkers([storeDistric], mapGoong, markerGoong);
            createSmoothscroll(document.documentElement.scrollTop || document.body.scrollTop, 300);
        };

        const searchPosition = async (storeByCity, storeDistric, indexs) => {
            if (showTimeLine.value == indexs) {
                showTimeLine.value = "";
            } else {
                showTimeLine.value = indexs;
                const params = {
                    store_id: storeDistric.simistorelocator_id
                };

                dataLocation.value = await detailStore(params);
                
                // Track store detail view event after fetching store details
                trackStoreDetailView(storeDistric);
            }
        };
        
        // Function to track store detail view event
        const trackStoreDetailView = (store: FindStoreResults) => {
            if (!process.client || !window.clevertap) return;
            if (!store) return;
            
            try {
                // Prepare tracking data
                const trackingData = {
                    view_method: 'from_store_list',
                    city: store.state || '',
                    district: store.city || '',
                    store_id: store.store_code || store.simistorelocator_id || '',
                    store_name: store.store_name || '',
                    store_address: store.address || '',
                    store_phone_number: store.phone || '',
                    store_latitude: store.latitude || '',
                    store_longitude: store.longitude || ''
                };
                
                // Send event to CleverTap
                clevertapStore.storeDetailViewedCleverTap({
                    data: trackingData,
                    clevertap: window.clevertap
                });
            } catch (error) {
                console.error('Error tracking store detail view:', error);
            }
        };

        // Helper function to remove trailing commas from string
        const clearLastChar = (str: string): string => {
            if (!str) return '';
            return str.slice(0, -1);
        };

        // Function to track store list viewed event
        const trackStoreListViewed = (storeList: FindStoreResults[], viewMethod: string = 'from_find_store') => {
            if (!process.client || !window.clevertap) return;
            if (!storeList || storeList.length === 0) return;
            
            try {
                let listStoreId = '';
                let listStoreName = '';
                let listStoreAddress = '';
                let listStorePhoneNumber = '';
                let listStoreLatitude = '';
                let listStoreLongitude = '';
                
                // Process each store to build data strings
                storeList.forEach((element, index) => {
                    if (index < 15) { // Limit to 15 stores to prevent data size issues
                        listStoreId += `"store_id_${index + 1}":"${element?.store_code || element?.simistorelocator_id}",`;
                        listStoreName += `"store_name_${index + 1}":"${element?.store_name}",`;
                        listStoreAddress += `"store_address_${index + 1}":"${element?.address}",`;
                        listStorePhoneNumber += `"store_phone_number_${index + 1}":"${element?.phone}",`;
                        listStoreLatitude += `"store_latitude_${index + 1}":"${element?.latitude}",`;
                        listStoreLongitude += `"store_longitude_${index + 1}":"${element?.longitude}",`;
                    }
                });
                
                // Parse JSON data objects
                let ObjectItemId = JSON.parse(`{${clearLastChar(listStoreId)}}`);
                let ObjectItemName = JSON.parse(`{${clearLastChar(listStoreName)}}`);
                let ObjectItemAddress = JSON.parse(`{${clearLastChar(listStoreAddress)}}`);
                let ObjectItemPhoneNumber = JSON.parse(`{${clearLastChar(listStorePhoneNumber)}}`);
                let ObjectItemLatitude = JSON.parse(`{${clearLastChar(listStoreLatitude)}}`);
                let ObjectItemLongitude = JSON.parse(`{${clearLastChar(listStoreLongitude)}}`);
                
                // Prepare event data
                const eventData = {
                    view_method: viewMethod,
                    city: cities.value?.find((e) => e.text === selectedCity.value)?.value || '',
                    district: selectedDistrict.value || '',
                    ...ObjectItemId,
                    ...ObjectItemName,
                    ...ObjectItemAddress,
                    ...ObjectItemPhoneNumber,
                    ...ObjectItemLatitude,
                    ...ObjectItemLongitude,
                };
                
                // Send event to CleverTap
                clevertapStore.storeListViewedCleverTap({
                    data: eventData,
                    clevertap: window.clevertap
                });
            } catch (error) {
                console.error('Error tracking store list view:', error);
            }
        };

        onMounted(() => {
            const script = document.createElement("script");
            script.src = "https://cdn.jsdelivr.net/npm/@goongmaps/goong-js@1.0.9/dist/goong-js.min.js";
            script.onload = () => {
                const link = document.createElement("link");
                link.href = "https://cdn.jsdelivr.net/npm/@goongmaps/goong-js@1.0.9/dist/goong-js.css";
                link.rel = "stylesheet";
                link.onload = () => initMap(mapGoong, goongjsConfig.keyGoong);
                document.head.appendChild(link);
            };
            document.head.appendChild(script);
        });

        return {
            cities,
            stores,
            loading,
            districts,
            selectedCity,
            selectedDistrict,
            idStore,
            storeInMap,
            gotoGgMap,
            storeByCity,
            getStoreByCity,
            checkIndexStore,
            dataLocation,
            showTimeLine,
            storeHighLight,
            stopScrollBody,
            startScrollBody,
            goToMap,
            imageStore,
            searchPosition,
            timeToMinutes,
            getStoreStatusText,
            getStoreStatusStyle,
            trackStoreListViewed,
            clearLastChar
        };
    },
});
